var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "493 366 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M513.4,390.3c-0.7,0-1.2,0.6-1.2,1.2c0,0.7,0.6,1.2,1.2,1.2h18.9c0.7,0,1.2-0.6,1.2-1.2   c0-0.7-0.6-1.2-1.2-1.2H513.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M542.6,390.3h-4.8c-0.7,0-1.2,0.6-1.2,1.2c0,0.7,0.6,1.2,1.2,1.2h4.8c0.7,0,1.2-0.6,1.2-1.2   C543.8,390.8,543.3,390.3,542.6,390.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M529.2,385.6c0,0.7,0.6,1.2,1.2,1.2h4.8c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2h-4.8   C529.7,384.4,529.2,385,529.2,385.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M524.8,381.3h4.8c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2h-4.8c-0.7,0-1.2,0.6-1.2,1.2   C523.5,380.7,524.1,381.3,524.8,381.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M538.3,396h-25.3c0,0,0,0,0,0c0,0-0.1,0-0.1,0c-3.1,0-5.9,1.5-7.7,3.9c-2.6,3.5-1.8,8.5,1.7,11   c2.9,2.1,7,1.5,9.2-1.5c1.8-2.5,1.2-5.9-1.2-7.7c-2.1-1.5-5-1-6.5,1c-1.3,1.8-0.9,4.3,0.9,5.5c0.7,0.5,1.4,0.7,2.2,0.6   c0.7,0,1.2-0.6,1.2-1.3c0-0.7-0.6-1.2-1.3-1.2c-0.1,0-0.4,0-0.6-0.2c-0.7-0.5-0.8-1.4-0.3-2.1c0.7-1,2-1.2,3-0.5   c1.3,1,1.6,2.9,0.7,4.2c-1.3,1.8-3.9,2.2-5.7,0.9c-2.4-1.7-2.9-5.1-1.2-7.5c1.3-1.8,3.5-2.9,5.8-2.9c0,0,0,0,0,0c0,0,0,0,0,0h25.3   c0.7,0,1.2-0.6,1.2-1.2C539.6,396.6,539,396,538.3,396z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M524.6,386.9c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2h-21.4c0,0,0,0,0,0c0,0-0.1,0-0.1,0   c-2.3,0-4.4-1.1-5.7-2.9c-1.7-2.4-1.2-5.8,1.2-7.5c0.9-0.6,2-0.9,3-0.7c1.1,0.2,2,0.7,2.6,1.6c1,1.3,0.7,3.2-0.7,4.2   c-1,0.7-2.3,0.5-3-0.5c-0.5-0.7-0.3-1.6,0.3-2.1c0,0,0,0,0,0c0.1-0.1,0.2-0.1,0.3-0.2c0.7-0.2,1.1-0.8,0.9-1.5   c-0.1-0.6-0.6-1-1.2-1c-0.1,0-0.2,0-0.3,0c-0.5,0.1-0.9,0.3-1.3,0.6c0,0,0,0,0,0c-1.8,1.3-2.2,3.8-0.9,5.5c1.5,2.1,4.4,2.5,6.5,1   c2.5-1.8,3-5.2,1.2-7.7c-1-1.4-2.6-2.3-4.3-2.6c-0.3-0.1-0.7-0.1-1-0.1c-1.4,0-2.7,0.4-3.8,1.3c-3.5,2.6-4.3,7.5-1.7,11   c1.8,2.5,4.7,3.9,7.7,3.9c0,0,0.1,0,0.1,0c0,0,0,0,0,0H524.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindSpeed);
export default __webpack_public_path__ + "static/media/wind-speed.2cbf6d2a7918b28b438fbd15d9531e29.svg";
export { ForwardRef as ReactComponent };